export default "__VITE_ASSET__CEu8eaac__"